﻿import Vue from "vue";
import common from "../../common";
import context_ from "../context";
import core from "../../core";
import EditVue_ from "../vue/EditVue";
import HotEditableFormAction_ from "../vue/hotEditable/HotEditableFormAction";
import utilities_ from "../utilities";
import FormService_ from "../../services/FormService";
import FormNode_ from "../vue/hotEditable/FormNode";
import PageService_ from "../../services/PageService";

declare function require(module: string): unknown;
const context = require("../context") as typeof context_;
const utilities = require("../utilities") as typeof utilities_;
// const EditVue = require("../vue/EditVue") as EditVue_;
// const HotEditableFormAction = require("../vue/hotEditable/HotEditableFormAction") as HotEditableFormAction_;
// const FormService = require("../../services/FormService") as FormService_;
// const FormNode = require("../vue/hotEditable/FormNode") as FormNode_;
// const PageService = require("../../services/PageService") as PageService_;
//const jsClasses = require("../../../js/jsClasses") as any;

interface ISettings {
    /** Valeur de l'attribut HTML "name" du formulaire contenant les champs */
    formName: string;
    /** Valeur de l'attribut HTML "id" du module Vuejs */
    vueElId: string;
    /** URL de l'API qui sera appeler lors de la sauvegarde  */
    updateApiUrl: string;
    /** Permet de gerer manuellement les boutons du formulaires lors des changements de mode de formulaire (original/edition). 
     * Default: TRUE */
    disableManageButtonsOnFormModeChange?: boolean;
    customData?: common.IPostCustomData;
    /** URL correspondant a la page precedente (doit etre definie si l'option "useBrowserHistoryToGoBackOnCancel" est activee) */
    previousPageUrl?: string;
    concurrencySumCheck: string;
}

interface IResponseData extends common.IHotEditableFormResponseData {
    enableCreationButton?: boolean;
    enableRefuseButton?: boolean;
}

class FermeSommaireFluxDeTravaux implements common.IWebComponent {
    private _isInit = false;
    private _formService?: FormService_;
    private _pageService?: PageService_;
    private _editVue = null as EditVue_ | null;
    private _loader = null as core.Loader | null;
    private _vueElId?: string;
    private _updateApiUrl?: string | null;
    private _liveUpdateOnEditMode?: boolean;
    private _isEditionAlwaysOn?: boolean;
    private _confirmPopup = null as core.ConfirmationPopup | null;
    private _createWorkflowPopup = null as core.ConfirmationPopup | null;
    private _customData = null as common.IPostCustomData | null;
    private _previousPageUrl?: string | null;

    init(s: ISettings) {
        if (this._isInit)
            return;
        this._isInit = true;

        // configuration
        this._updateApiUrl = s.updateApiUrl || null;
        this._vueElId = s.vueElId || (() => { throw "La propriété 'settings.vueElId' est requise."; })();
        this._isEditionAlwaysOn = true;
        this._liveUpdateOnEditMode = false;
        this._customData = s.customData || {};
        this._previousPageUrl = s.previousPageUrl || null;

        this._pageService = new PageService_();
        this._formService = new FormService_(s.formName);
        this._loader = new core.Loader(this._vueElId);
        this._confirmPopup = new core.ConfirmationPopup("#ActionConfirmPopup.mod-popup");

        this._createWorkflowPopup = new core.ConfirmationPopup("#CreateWorkflowPopup.mod-popup", null, null, null, null, "#CreateWorkflowPopupBackground.mod-popup-background", "dawn");

        this.setupVue(s);

        return this;
    }


    destroy() {
        this._editVue?.shared?.destroyComponentsByNode();
        this._editVue?.$destroy();
        this._editVue = null;//DESTROY (TEST)
    }
    private setupVue(s: ISettings) {

        Vue.prototype.$initialData = {
            vueElId: this._vueElId,
            formName: s.formName,
            loadFormModeFromUrl: false,
            includesConcurrencySumCheck: true,
            concurrencySumCheck: s.concurrencySumCheck || null
        };

        this._editVue = new EditVue_();

        if (s.disableManageButtonsOnFormModeChange === true)
            this._editVue?.setManageButtonsOnFormModeChange(false);

        this._editVue?.shared?.setActionCallback((a: HotEditableFormAction_) => {
            this.onFormAction(a);
        }).setErrorCallback((errors: common.IError[], config?: common.IHotEditableFormConfig) => {
            this.onFormActionError(errors, null, config);
        });

        this._editVue?.shared?.setupForm(this._isEditionAlwaysOn);
    }
    registerFormManagerParentNode(parent: FormNode_, containerFieldName: string, url: string | null) {
        if (this._editVue?.formManager?.formNode) {
            this._editVue.formManager.formNode.onRegister(containerFieldName, url, this);
            parent?.registerChildNode(this._editVue.formManager.formNode);
        }
        return this;
    }
    /** Sera appelé par le embedded field pour y injecter le navContext */
    insertNavContextHiddenField(navContextId: string) {
        utilities.insertNavContextHiddenField(this._editVue?.shared?.getFormName(), navContextId);
        return this;
    }
    // /** Sera appelé par le embedded field pour y injecter le sum check */
    // insertConcurrencySumCheckHiddenField(sumCheck: string) {
    //     utilities.insertConcurrencySumCheckHiddenField(this._editVue?.shared?.getFormName(), sumCheck);
    //     return this;
    // }

    private onFormAction(action: HotEditableFormAction_) {
        if (this._formService?.actionHasError(action))
            return;

        const isEditionFormMode = action.isEditionFormMode();
        const actionValue = action.getActionValue();
        var actionType = action.getActionType();

        const createWorkflowActionValue = 'CreateWorkflow';
        if (actionType === common.HotEditableActionTypes.apply)
            if (actionValue === createWorkflowActionValue) {

                this._createWorkflowPopup?.showWithAction(() => {
                    this._editVue?.applyUpdate(createWorkflowActionValue, common.HotEditableActionTypes.create);
                }, () => {
                    this._editVue?.updateFieldTextualValue("CreateWorkflowPopup_WorkflowType");
                });

                return;
            }

        if (this._liveUpdateOnEditMode && actionType === common.HotEditableActionTypes.unknown)
            actionType = common.HotEditableActionTypes.update;

        if (isEditionFormMode && actionType === common.HotEditableActionTypes.unknown)
            return;

        this._formService?.validateAndPost(
            this._updateApiUrl,
            null,
            {
                posted_actionType: actionType,
                posted_actionValue: actionValue,
                posted_formName: this._editVue?.shared?.getFormName(),
                posted_fieldName: action.getFieldOrButtonName(),
                posted_currentCulture: context.culture.get(),
                posted_currentUrl: utilities.currentUrl(),
                posted_customData: utilities.ensureCustomDataIsValid(this._customData),
                posted_previousPageUrl: this._previousPageUrl,
                posted_currentEmbeddedComponentName: this._editVue?.shared?.getCurrentEmbeddedComponentName(),
                posted_bag: this._editVue?.getBagRaw(),
                posted_isControlClick: action.getButtonClickContext().isCtlClick === true
            } as common.IHotEditableFormPostArguments,
            (data: IResponseData) => {
                this.onFormActionSuccess(action, data);
            },
            (e: any, config: any) => {
                this.onFormActionError(e, action, config);
            });

    }

    private onFormActionSuccess(action: HotEditableFormAction_, data?: IResponseData) {
        data = data || {};

        const actionType = action.getActionType();
        const actionValue = action.getActionValue();
        const isButtonClick = action.isButtonClick();
        const isEditionFormMode = action.isEditionFormMode();
        const isUpdateAction = actionType === common.HotEditableActionTypes.update;
        const isDeleteAction = !isUpdateAction && actionType === common.HotEditableActionTypes.delete;
        const showMessages = data.disableAllMessages !== true;
        const showAutoSuccessMessages = showMessages && data.disableAutomaticMessages !== true;
        const changedFieldName = action.getFieldName();
        const buttonClickContext = action.getButtonClickContext();

        if (data.outdatedContent)
            return this._pageService?.applyOutdatedContent(data, this._editVue);

        // Doit etre ouvert avant le refresh du widget si une URL de fichier typiquement en target=blank
        const openRedirectUrlInBlankPage = data.redirectUrl && utilities.openInBlankPage(data.redirectUrlOptions);
        if (openRedirectUrlInBlankPage)
            utilities.redirectWithDelay(data.redirectUrl, 1, true);

        const displayCustomMessage = (immediateDisplay: boolean, text: string, name?: string, messageType?: common.MessageTypes, autoClose?: boolean) => {
            messageType = messageType || common.MessageTypes.success//<- default is success
            if (this._editVue?.shared)
                if (!this._editVue.shared.displayMessage(name, text, messageType))
                    this._formService?.displayMessage(text, messageType, immediateDisplay, autoClose);
        }
        if (!this._editVue?.shared) {
            //debugger;
            console.warn("[UPA] 'EditVue' already disposed.");
            return;
        }

        var succesMessageSended = false;
        if (this._editVue?.shared?.isHotEmbeddedComponent()) {
            // Widgets -> brothers
            if (data.refreshBrotherEmbeddedComponents)
                this._editVue?.refreshBrotherEmbeddedComponents();
            else if (data.restoreBrotherEmbeddedComponents)
                this._editVue?.restoreBrotherEmbeddedComponents();
            else if (data.ensureBrotherEmbeddedComponentsIsDefaultUrl)
                this._editVue?.ensureBrotherEmbeddedComponentsIsDefaultUrl();
            // Widgets -> all
            if (data.hotEmbeddedComponentsToUpdate?.length) {
                if (showMessages) {
                    const updateCurrentEmbededForm = utilities.any(data.hotEmbeddedComponentsToUpdate, x => !x.name);
                    if (updateCurrentEmbededForm && data.messages?.length) {
                        for (let i = 0; i < data.messages.length; i++) {
                            const m = data.messages[i];
                            const ac = m.autoClose === true || m.autoClose === false ? m.autoClose : true;//default=TRUE
                            displayCustomMessage(true, m.text, m.name, m.messageType, ac);
                        }
                        // if (!this._editVue?.shared?.displayMessage(data.messageName, data.messages, customMessageType))
                        //     this._formService?.displayMessage(data.messages, customMessageType, false, true);
                    } else if (showAutoSuccessMessages && !succesMessageSended) {
                        this._formService?.displaySuccessMessageFromAction(action, true, true, this._liveUpdateOnEditMode);
                        succesMessageSended = true;
                    }
                }

                if (this._editVue?.shared)
                    if (this._editVue.shared.updateHotEmbeddedComponents(data.hotEmbeddedComponentsToUpdate))
                        return;
            }
        }

        if (isDeleteAction) {
            var redirectUrl = data.redirectUrl;
            if (!redirectUrl && data.forceRedirectOnDeleteAction)
                redirectUrl = '/';
            if (redirectUrl) {
                utilities.redirect(redirectUrl);
                return;
            }
        }

        this._editVue?.shared?.updateConcurrencySumCheck(data.updatedConcurrencySumCheck);
        this._editVue?.updateBag(data.bag);

        const repost = () => this._editVue?.shared?.applyUpdate(actionValue, actionType, isButtonClick, buttonClickContext, changedFieldName);
        if (FormService_.confirm(
            this._editVue?.formManager?.getFormName(),
            this._confirmPopup,
            data?.confirmationMessages,
            () => {
                // Accepted
                repost();
            },
            (returnToApiOnDenied: boolean) => {
                // Denied

                if (returnToApiOnDenied) {
                    repost();
                    return;
                }

                if (this._editVue?.shared?.confirmationRejected())
                    this._formService?.displayNotSavedErrorMessageImediately();
            }))
            return;

        if (isUpdateAction || data.redirectUrl) {
            const url = data.redirectUrl || this._previousPageUrl || null;
            if (url) {
                if (showMessages)
                    if (data.messages?.length) {
                        for (let i = 0; i < data.messages.length; i++) {
                            const m = data.messages[i];
                            const ac = m.autoClose === true || m.autoClose === false ? m.autoClose : true;//default=TRUE
                            displayCustomMessage(false, m.text, m.name, m.messageType, ac);
                        }

                        // if (!this._editVue?.shared?.displayMessage(data.messageName, data.messages, customMessageType))
                        //     this._formService?.displayMessage(data.messages, customMessageType, false, true);
                    } else if (showAutoSuccessMessages && !succesMessageSended) {
                        this._formService?.displaySuccessMessageFromAction(action, false, true, this._liveUpdateOnEditMode);
                        succesMessageSended = true;
                    }

                if (!openRedirectUrlInBlankPage)
                    // Ne pas rouvrir une seconde fois l'url en target=blank
                    utilities.redirectWithOptions(url, data.redirectUrlOptions);

                return;
            }
        }

        if (data.enableCreationButton === true || data.enableCreationButton === false)
            this.enableCreateButton(data.enableCreationButton);

        if (data.enableRefuseButton === true || data.enableRefuseButton === false)
            this.enableRefuseButton(data.enableRefuseButton);

        if (data.fieldsToUpdate)
            for (let i = 0; i < data.fieldsToUpdate.length; i++) {
                const updatedField = data.fieldsToUpdate[i];
                if (updatedField)
                    this._editVue?.shared?.updateFieldFromApi(updatedField);
            }

        if (showMessages)
            if (data.messages?.length) {
                for (let i = 0; i < data.messages.length; i++) {
                    const m = data.messages[i];
                    const ac = m.autoClose === true || m.autoClose === false ? m.autoClose : true;//default=TRUE
                    displayCustomMessage(true, m.text, m.name, m.messageType, ac);
                }
                // if (!this._editVue?.shared?.displayMessage(data.messageName, data.messages, customMessageType))
                //     this._formService?.displayMessage(data.messages, customMessageType, true, true);
            }
            else if (showAutoSuccessMessages && !succesMessageSended) {
                this._formService?.displaySuccessMessageFromAction(action, true, true, this._liveUpdateOnEditMode);
                succesMessageSended = true;
            }

        if (isEditionFormMode && !this._liveUpdateOnEditMode)
            this._editVue?.shared?.setAsHotEditableFormMode();
    }

    private onFormActionError(errors: common.IError[], action?: HotEditableFormAction_ | null, config?: common.IHotEditableFormConfig) {
        config = config || {};

        for (let i = 0; i < errors.length; i++) {
            const error = errors[i];

            if (error.code !== 110) {

                if (context.env.currentIsDev || context.env.currentIsLocal) {
                    utilities.printError(error.message + ' (code: ' + error.code + ')');
                    this._formService?.displayErrorImediately(new core.Error("Une erreur système est survenue et est affichée dans la console du navigateur.", error.code));
                }
                else
                    this._formService?.displayErrorImediately(new core.Error(error.message));

                return;
            }

            if (config.disableAutomaticMessages)
                return;

            // Functional
            const fieldFound = this._editVue?.shared?.displayFieldError(this._editVue?.shared?.getFormName(), error, true);
            if (fieldFound) {
                this._formService?.displayNotSavedErrorMessageImediately();
                return;
            }

            this._formService?.displayErrorImediately(new core.Error(error.message));
        }
    }

    private enableCreateButton(value?: boolean) {
        value = value !== false;//default is TRUE
        this._editVue?.shared?.disabledField("Update", !value);
    }

    private enableRefuseButton(value?: boolean) {
        value = value !== false;//default is TRUE
        this._editVue?.shared?.disabledField("Refuse", !value);
    }
}

export = FermeSommaireFluxDeTravaux;